import { createContext, useContext, useMemo, ReactNode } from 'react';

import { useLoadWebSchedulerScript } from './hooks/useLoadWebSchedulerScript';

interface SchedulerContextProps {
    webSchedulerScriptLoadedSuccessfully: boolean;
}

const SchedulerContext = createContext<SchedulerContextProps>(null!);

interface WebSchedulerProviderProps {
    children: ReactNode;
    publicCode: string;
    scriptUrl: string;
}

export function WebSchedulerProvider({
    children,
    publicCode,
    scriptUrl,
}: WebSchedulerProviderProps) {
    if (!publicCode || !scriptUrl) {
        throw new Error('publicCode and scriptUrl are required');
    }

    const webSchedulerScriptLoadedSuccessfully = useLoadWebSchedulerScript({
        publicCode,
        scriptUrl,
    });

    const contextValue = useMemo(
        () => ({
            webSchedulerScriptLoadedSuccessfully,
        }),
        [webSchedulerScriptLoadedSuccessfully]
    );

    return <SchedulerContext.Provider value={contextValue}>{children}</SchedulerContext.Provider>;
}

export function useWebScheduler() {
    const context = useContext(SchedulerContext);
    if (!context) {
        throw new Error('Web Scheduler components must be used within SchedulerProvider');
    }
    return context;
}
